import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
  balance: null,
  login: false,
  loading: false,
  error: false,
  errorData: null
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginRequest(state) {
      return { ...state, loading: true };
    },
    loginSuccess(state, { payload }) {
      return { ...state, loading: false, login: true, data: payload };
    },
    setBalance(state , {payload}) {
      return { ...state, balance: payload };
    },
    loginFailure(state, { payload }) {
      return { ...state, loading: false, error: true, errorData: payload };
    },
    loginWithOTP(state) {
      return { ...state, loading: false, login: false };
    },
    logout() {
      return initialState;
    }
  }
});

export const getUser = (state) => state?.user?.data;
export const isUserLoggedIn = (state) => state.user?.login;

export const {
  loginRequest,
  loginSuccess,
  setBalance,
  loginFailure,
  loginWithOTP,
  logout
} = userSlice.actions;

export default userSlice.reducer;
